import React, {
  MutableRefObject,
  RefObject,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import * as _ from 'lodash';
import {
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Row,
  Tooltip,
  Button,
} from 'antd';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow-down-icon.svg';
import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar-icon.svg';
import StyledButton from 'app/components/StyledButton';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import StyledDatePicker from 'app/pages/NewAccount/components/StyledDatePicker';
import StyledSearchInput from 'app/pages/NewAccount/components/StyledSearchInput';
import StyledSelect, {
  MobileStyledSelect,
} from 'app/pages/NewAccount/components/StyledSelect';
import moment from 'moment';
import { ReactComponent as FilterActiveIcon } from 'app/assets/img/filter-active-icon.svg';
import { LoadingOutlined } from '@ant-design/icons';

import { useDispatch, useSelector } from 'react-redux';
import { I_Agents } from 'app/pages/NewAccount/CheckTickets/slice/types';
import {
  getDataAgentApi,
  getDataSelectTicketApi,
} from 'app/services/checkTicketApi';
import RangeDatePickerCustom from './RangeDatePickerCustom';
import styled from 'styled-components';
import { StyledInputFilter, StyledPopover } from './styled';
import { CustomPopoverContent } from 'app/pages/Catalog/components/helper';
import { convertVItoEN, listObject, listType } from './helper';
import { objectType } from 'types';
import { getDayOfWeekString } from 'utils/time';
import DatePickerComponent from 'app/components/DatePickerComponent';
import { BP_TYPE } from 'utils/constants';
import useAllocatedDebt from 'app/hooks/useAllocatedDebt';
import { Permission } from 'app/hooks/usePermission';
import { ORDER_SOURCE_OPTIONS } from '../PurchaseHistory';
type SearchComponentProps = {
  travelLocation: {
    value: string;
    label: string;
  }[];
  onSubmitSearh: (params: any) => void;
  paramSearch?: any;
  listStatus?: any;
  filters?: any;
  listOrderTypeStr?: any;
  listZone?: any;
  listPerformance?: any;
  listRestaurant?: any;
  listGroupCode: { label: string; value: string }[];
  ticketTypeOptions?: any;
};

const formatDate = (
  date: moment.Moment,
  translation: objectType | undefined,
) => {
  const dayOfWeek = getDayOfWeekString(date, translation);
  // Format the rest of the date
  return `${dayOfWeek} ${date.format('(DD/MM/YYYY)')}`;
};

const StyledFilterActiveIcon = styled(FilterActiveIcon)`
  path {
    fill: #000000;
    stroke: #000000;
  }
`;

export const DesktopSearchMobileComponent = (props: SearchComponentProps) => {
  const { onSubmitSearh, filters, travelLocation, listStatus } = props;
  const [menuVisible, setMenuVisible] = useState(false);

  const translations = useSelector(selectTranslations);

  return (
    <Form>
      <Dropdown
        visible={menuVisible}
        trigger={['click']}
        onVisibleChange={visible => setMenuVisible(visible)}
        getPopupContainer={trigger => trigger.parentNode as HTMLElement}
        overlayStyle={{ zIndex: 3 }}
        overlay={
          <MobileSearchOverlay {...props} setMenuVisible={setMenuVisible} />
        }
      >
        <StyledButton
          bgColor="#fff"
          style={{
            border: '1px solid #EDEDED',
            borderRadius: 10,
            width: 41,
            height: 41,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            marginTop: 10,
          }}
        >
          <StyledFilterActiveIcon width={16} height={16} />
        </StyledButton>
      </Dropdown>
    </Form>
  );
};

const MobileSearchOverlay = ({
  travelLocation,
  listStatus,
  onSubmitSearh,
  setMenuVisible,
  filters,
  listOrderTypeStr,
  listPerformance,
  // listZone,
  listRestaurant,
  listGroupCode,
  ticketTypeOptions,
}: SearchComponentProps & {
  setMenuVisible: (show: boolean) => void;
  ticketTypeOptions?: any;
}) => {
  const translations = useSelector(selectTranslations);
  const userInfo = useSelector(selectInfoUser);
  const [dataAgent, setDataAgent] = useState<any[]>([]);
  const [dataProduct, setDataProduct] = useState<any[]>([]);
  const [paramsSearch, setParamsSearch] = useState(filters);
  const initParamProducts: any = { limit: 50, page: 1, search: '', last: null };
  const paramsProducts = useRef(initParamProducts);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [valueType, setValueType] = useState<any>(filters?.areaType || []);
  const [valueObject, setValueObject] = useState<any>(filters?.ageType || []);
  const ticketTypeFilterContainer = useRef<HTMLDivElement>(null);
  const isProxyBuyer =
    (userInfo?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const [allocatedSearch, setAllocatedSearch] = useState('');

  const { result: allocatedDebtData } = useAllocatedDebt({
    IIFE: isProxyBuyer,
    search: allocatedSearch,
  });

  const isSaleMng =
    userInfo?.role_code === Permission.ROLE_SALE_MANAGER ||
    userInfo?.role_code === Permission.ROLE_SALE_SHG;
  const getDataAgent = async () => {
    try {
      const { data } = await getDataAgentApi();
      if (!_.isEmpty(data?.data)) {
        const resAgents = data?.data.map((item: any) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
        setDataAgent(
          isSaleMng
            ? [
                {
                  id: 0,
                  label: translations ? translations['b2b.text.all'] : '',
                  value: 'All',
                },
                ...resAgents,
              ]
            : resAgents,
        );
      }
    } catch (error) {}
  };

  const getDataProduct = async (params: I_Agents) => {
    setLoadingProducts(true);
    try {
      if (paramsProducts.current.page > +(params.page as number)) {
        setLoadingProducts(false);
        return;
      }
      const { data } = await getDataSelectTicketApi(params);
      if (data?.paginator) {
        paramsProducts.current = {
          ...paramsProducts.current,
          last: +data?.paginator.last,
          page: +data?.paginator.current,
        };
      }
      const resProducts = _.isEmpty(data?.data)
        ? []
        : data?.data.map((item: any) => {
            return {
              label: item.name || item.id,
              value: item.id,
            };
          });

      setDataProduct(Array.from(new Set([...dataProduct, ...resProducts])));
    } catch (error) {
    } finally {
      setLoadingProducts(false);
    }
  };
  const handleScroll = e => {
    const isEndOfList = e.target.scrollTop > (4 / 5) * e.target.scrollHeight;
    const endLoading =
      _.isNumber(paramsProducts.current.last) &&
      paramsProducts.current.page + 1 > +paramsProducts.current.last;

    if (isEndOfList && !endLoading) {
      getDataProduct({
        ...paramsProducts.current,
        page: paramsProducts.current.page + 1,
      });
    }
  };
  useEffect(() => {
    getDataAgent();
    getDataProduct({ limit: 50, page: 1, search: '' });
    // ticketTypeFilterContainer;
  }, []);
  const handleSearchProduct = async paramsSearch => {
    if (!_.isEmpty(paramsSearch)) {
      setLoadingProducts(true);
    }
    try {
      const { data } = await getDataSelectTicketApi({
        limit: paramsProducts.current.limit,
        search: paramsSearch,
        page: 1,
      });
      if (data?.paginator) {
        paramsProducts.current = {
          ...paramsProducts.current,
          last: +data?.paginator.last,
          page: +data?.paginator.current,
        };
      }
      const resProducts = _.isEmpty(data?.data)
        ? []
        : data?.data.map((item: any) => {
            return {
              label: item.name || item.id,
              value: item.id,
            };
          });
      setDataProduct(resProducts);
    } catch (error) {
    } finally {
      setLoadingProducts(false);
    }
  };
  const onChangeType = (valueType: any) => {
    setParamsSearch({
      ...paramsSearch,
      areaType: valueType,
    });
    setValueType(valueType);
  };
  const onChangeObject = (valueAge: any) => {
    setParamsSearch({
      ...paramsSearch,
      ageType: valueAge,
    });
    setValueObject(valueAge);
  };
  const getValueTypeFilter = () => {
    let text = '';
    const arrObject = listObject(translations).filter(item =>
      valueObject.includes(item.value),
    );
    const arrType = listType(translations).filter(item =>
      valueType.includes(item.value),
    );
    const arrGroup: any = [...arrObject, ...arrType];
    const textGroup = arrGroup.map((i: any) => i?.label);
    text = textGroup.toString();
    return text;
  };

  const removeFocusInput = () => {
    const currentDiv = document.getElementById('search-order-id');
    if (currentDiv) {
      currentDiv.blur();
    }
  };

  return (
    <Form>
      <div
        style={{
          padding: '16px',
          backgroundColor: 'white',
          borderRadius: 8,
          boxShadow: ' rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
          display: 'flex',
          flexDirection: 'column',
          width: 332,
        }}
        ref={ticketTypeFilterContainer}
      >
        <div style={{ minWidth: 'fit-content', marginBottom: 6 }}>
          {translations?.['b2b.txt.validFromDate']}
        </div>
        <RangeDatePickerContainer>
          <RangeDatePickerCustom
            placeholder={
              translations ? translations['b2b.txt.ticket-expried'] : ''
            }
            startDateInit={new Date(paramsSearch?.expiredDateFrom)}
            endDateInit={new Date(paramsSearch?.expiredDateTo)}
            syncFromProps
            onChange={value => {
              const [startDate, endDate] = value;
              if (!startDate) {
                setParamsSearch({
                  ...paramsSearch,
                  expiredDateFrom: '',
                  expiredDateTo: '',
                });
                return;
              }
              let finalEndDate = endDate ?? startDate;
              const maxEndDate = moment(startDate).add(30, 'days').toDate();
              if (finalEndDate > maxEndDate) {
                finalEndDate = maxEndDate;
              }
              setParamsSearch({
                ...paramsSearch,
                expiredDateFrom: moment(startDate).format('YYYY-MM-DD'),
                expiredDateTo: moment(finalEndDate).format('YYYY-MM-DD'),
              });
            }}
            minDate={null}
          />
        </RangeDatePickerContainer>
        <DatePickerComponent
          style={{
            marginBottom: 8,
            width: '100%',
            border: 'solid 1px #d9d9d9',
            height: 44,
            padding: '0 11px',
            borderRadius: 6,
          }}
          suffixIcon={<CalendarIcon />}
          allowClear
          placeholder={translations ? translations['b2c.txt.date-order'] : ''}
          format={date => formatDate(date, translations)}
          // value={paramsSearch.orderDate ? moment(paramsSearch.orderDate) : null}
          onChange={(e: any) => {
            setParamsSearch({
              ...paramsSearch,
              orderDate: moment(e)?.isValid()
                ? moment(e).format('YYYY-MM-DD')
                : '',
            });
          }}
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.park}
          suffixIcon={<ArrowDownIcon />}
          style={{ width: '100%', marginBottom: 8 }}
          placeholder={translations ? translations['b2c.txt.park'] : ''}
          onChange={val =>
            setParamsSearch({
              ...paramsSearch,
              park: val,
            })
          }
          options={travelLocation}
          dropdownStyle={{ zIndex: 4 }}
          getPopupContainer={() => ticketTypeFilterContainer.current!}
          allowClear
        />
        <StyledSearchInput
          id="search-order-id"
          placeholder={
            translations
              ? translations['b2b.txt.search-place-holder-check-tickets']
              : ''
          }
          onBlur={e => {
            setParamsSearch({
              ...paramsSearch,
              searchOrderId: e?.target?.value?.trim(),
            });
          }}
          style={{
            margin: '0px 0px 8px 0px',
          }}
          onChange={e =>
            setParamsSearch({
              ...paramsSearch,
              searchOrderId: e?.target?.value,
            })
          }
          value={paramsSearch.searchOrderId}
        />
        <StyledSelect
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.product_id}
          suffixIcon={
            loadingProducts ? (
              <LoadingOutlined
                style={{
                  fontSize: 20,
                  color: '#1890ff',
                }}
              />
            ) : (
              <ArrowDownIcon />
            )
          }
          placeholder={translations ? translations['b2b.booking.products'] : ''}
          onChange={val =>
            setParamsSearch({
              ...paramsSearch,
              product_id: val,
            })
          }
          mode="multiple"
          allowClear
          onBlur={() => {
            handleSearchProduct('');
          }}
          onSearch={_.debounce(handleSearchProduct, 300)}
          maxTagCount={'responsive'}
          options={dataProduct}
          style={{
            marginBottom: 8,
            width: '100%',
            maxWidth: '332px',
          }}
          dropdownStyle={{ zIndex: 4 }}
          filterOption={false}
          loading={loadingProducts}
          onPopupScroll={_.debounce(handleScroll, 150)}
          onClear={() => {
            handleSearchProduct('');
          }}
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.agent}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.orderer'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, agent: val })}
          options={dataAgent}
          allowClear
          style={{
            marginBottom: 8,
            width: '100%',
            maxWidth: '332px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
          dropdownStyle={{ zIndex: 4 }}
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.orderTypeStr}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.order-type'] : ''}
          onChange={val =>
            setParamsSearch({ ...paramsSearch, orderTypeStr: val })
          }
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          options={listOrderTypeStr}
          allowClear
          className="dropdown-select-ticket-status"
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.status}
          suffixIcon={<ArrowDownIcon />}
          placeholder={
            translations ? translations['b2b.txt.ticket-status'] : ''
          }
          onChange={val => setParamsSearch({ ...paramsSearch, status: val })}
          allowClear
          options={listStatus}
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          dropdownStyle={{ zIndex: 4 }}
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        {/* <StyledSelect
          value={paramsSearch.zoneId}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.zone'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, zoneId: val })}
          options={listZone}
          allowClear
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          className="dropdown-select-zone"
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        /> */}
        <StyledSelect
          filterOption={(input, option) =>
            (convertVItoEN(option?.label) ?? '').includes(convertVItoEN(input))
          }
          showSearch
          isFocus
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.restaurantId}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2c.text.restaurants'] : ''}
          onChange={val =>
            setParamsSearch({ ...paramsSearch, restaurantId: val })
          }
          options={listRestaurant}
          allowClear
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          className="dropdown-select-zone"
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledSelect
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.performanceTime}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.hours'] : ''}
          onChange={val =>
            setParamsSearch({ ...paramsSearch, performanceTime: val })
          }
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          options={listPerformance}
          allowClear
          className="dropdown-select-zone"
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledPopover
          className="dropdown-filter-mobile"
          placement="topRight"
          content={CustomPopoverContent(
            valueType,
            onChangeType,
            valueObject,
            onChangeObject,
            listType(translations),
            listObject(translations),
          )}
          trigger="click"
          overlayInnerStyle={{
            borderRadius: '10px',
          }}
        >
          <Button
            style={{
              height: '43px',
              borderRadius: '6px',
              marginBottom: '8px',
            }}
          >
            <StyledInputFilter
              className="input-filter-mobile"
              value={getValueTypeFilter()}
              readOnly
              placeholder={translations ? translations['b2c.txt.filter'] : ''}
            />
            <img
              src="/static/img/icon_filter.svg"
              style={{
                filter: 'contrast(0)',
              }}
            />
          </Button>
        </StyledPopover>
        <StyledSelect
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.groupCode}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.group-code'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, groupCode: val })}
          options={listGroupCode}
          allowClear
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          className="dropdown-select-zone"
          getPopupContainer={() => ticketTypeFilterContainer.current!}
        />
        <StyledSelect
          onDropdownVisibleChange={() => {
            removeFocusInput();
          }}
          value={paramsSearch.type}
          suffixIcon={<ArrowDownIcon />}
          placeholder={translations ? translations['b2b.txt.ticket-type'] : ''}
          onChange={val => setParamsSearch({ ...paramsSearch, type: val })}
          style={{
            marginBottom: 8,
            width: '100%',
          }}
          options={ticketTypeOptions}
          allowClear
          className="dropdown-select-zone"
          getPopupContainer={() => ticketTypeFilterContainer.current!}
          mode="tags"
          maxTagCount="responsive"
        />
        {!isProxyBuyer && (
          <StyledSelect
            onDropdownVisibleChange={() => {
              removeFocusInput();
            }}
            value={paramsSearch?.orderSource}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.source'] : ''}
            onChange={val =>
              setParamsSearch({ ...paramsSearch, orderSource: val })
            }
            style={{
              marginBottom: 8,
              width: '100%',
            }}
            options={ORDER_SOURCE_OPTIONS.map(i => ({
              value: i.value,
              label: translations?.[i.labelKey] ?? '',
            }))}
            allowClear
            className="dropdown-select-zone"
            getPopupContainer={() => ticketTypeFilterContainer.current!}
          />
        )}
        {isProxyBuyer && (
          <StyledSelect
            filterOption={false}
            onSearch={value => {
              setAllocatedSearch(value);
            }}
            showSearch
            isFocus
            value={paramsSearch?.bpAllocatedDebt}
            suffixIcon={<ArrowDownIcon />}
            placeholder={translations ? translations['b2b.txt.authorized'] : ''}
            onChange={val => {
              setAllocatedSearch('');
              setParamsSearch({
                ...paramsSearch,
                bpAllocatedDebt: val,
              });
            }}
            options={allocatedDebtData?.map(i => ({
              value: i?.id,
              label: i?.name,
            }))}
            allowClear
            style={{ width: '100%', marginBottom: 8 }}
          />
        )}
        <StyledButton
          bgColor="white"
          border="1px solid #F8B117"
          textColor="#F8B117"
          width={'124px'}
          height={'44px'}
          onClick={() => {
            onSubmitSearh(paramsSearch);
            setMenuVisible(false);
          }}
        >
          {translations ? translations['b2c.txt.search'] : ''}
        </StyledButton>
      </div>
    </Form>
  );
};

const RangeDatePickerContainer = styled.div`
  width: 100%;
  .range-picker-container {
    margin-bottom: 8px;
    height: 44px;
    width: 100%;
    .react-datepicker-wrapper {
      height: 100%;
      .react-datepicker__input-container {
        height: 100%;
        .date-picker {
          height: 100%;
        }
      }
    }
  }
`;
